(function () {
  function refreshSelect(select) {
    // Save original options once
    if (!select.dataset.allOptionsHtml) {
      select.dataset.allOptionsHtml = select.innerHTML;
    }

    // Restore full list, then remove disabled ones (Dawn sets disabled based on current selection)
    select.innerHTML = select.dataset.allOptionsHtml;

    // Remove disabled options
    Array.from(select.options).forEach((opt) => {
      if (opt.disabled) opt.remove();
    });

    // If current value got removed, pick first available
    if (select.selectedIndex === -1 && select.options.length) {
      select.selectedIndex = 0;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function refreshAllWithin(container) {
    container.querySelectorAll("variant-selects select").forEach(refreshSelect);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("variant-selects").forEach((vs) => {
      // Run once on load
      refreshAllWithin(vs);

      // After Dawn updates disabled states, refresh again
      vs.addEventListener("change", () => {
        setTimeout(() => refreshAllWithin(vs), 0);
      });
    });
  });
})();